import React, { Component } from 'react';

import './App.css';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';


import { Layout } from 'antd';

import ToolBar from './components/ToolBar';
import SelectedComponent from './components/SelectedComponent'

import AppStore from './components/stores/AppStore';

const { Content, Footer } = Layout;

const minHeight = window.innerHeight * .89;


export default class App extends Component {
  constructor() {
    super();
    this.appStore = new AppStore();
    this.activityTimeout = null; // To store timeout reference
  }

  componentDidMount() {
    this.setActivityListeners();
    this.resetActivityTimeout(); // Start timeout on component mount
  }

  componentWillUnmount() {
    this.removeActivityListeners();
    if (this.activityTimeout) {
      clearTimeout(this.activityTimeout); // Clean up timeout when component unmounts
    }
  }

  // Set event listeners for user activity
  setActivityListeners = () => {
    window.addEventListener('click', this.resetActivityTimeout);
    window.addEventListener('keydown', this.resetActivityTimeout);
    window.addEventListener('mousemove', this.resetActivityTimeout);
    window.addEventListener('scroll', this.resetActivityTimeout);
  }

  // Remove event listeners when the component unmounts
  removeActivityListeners = () => {
    window.removeEventListener('click', this.resetActivityTimeout);
    window.removeEventListener('keydown', this.resetActivityTimeout);
    window.removeEventListener('mousemove', this.resetActivityTimeout);
    window.removeEventListener('scroll', this.resetActivityTimeout);
  }

  // Reset the timeout whenever there is activity
  resetActivityTimeout = () => {
    if (this.activityTimeout) {
      clearTimeout(this.activityTimeout); // Clear the previous timeout
    }

    // Set a new timeout for logout after 5 minutes of inactivity
    this.activityTimeout = setTimeout(() => {
      this.handleLogout();
    }, 30 * 60 * 1000); // 5 minutes in milliseconds
  }

  // Handle logout action
  handleLogout = () => {
    if (this.appStore.isLoggedIn()) {
      console.log("User has been logged out due to inactivity.");
      alert("User has been logged out due to inactivity.");
      this.appStore.logout(); // Call logout method from AppStore
    }

   
  }

  renderLayout = () => {
    return (
      <>
        <ToolBar appStore={this.appStore} />
        <Content className="site-layout" style={{ padding: '0 0px', marginTop: 64 }}>
          <div className="site-layout-background" style={{ padding: 2, minHeight: minHeight }}>
            <SelectedComponent appStore={this.appStore} />
          </div>
        </Content>
        <Footer style={{ padding: '0px 0px' }}></Footer>
      </>
    )
  }


  render() {
    return (
      <Layout>
        {this.renderLayout()}
      </Layout>
    )
  }
}
